import React, { useCallback, useRef, useEffect, useState } from 'react';
import {
  FiLogIn,
  FiMail,
  FiLock,
  FiKey,
  FiMessageCircle,
} from 'react-icons/fi';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';
import { rgb } from 'polished';
import {
  FaConnectdevelop,
  FaLock,
  FaHandPointUp,
  FaCertificate,
  FaTicketAlt,
  FaVideo,
  FaAward,
  FaSlideshare,
  FaKey,
} from 'react-icons/fa';
import { MdColorLens, MdMessage } from 'react-icons/md';
import { AiFillSafetyCertificate } from 'react-icons/ai';
import { IconType } from 'react-icons/lib';
import AreaExposicao from '../AreaExposicao';
import AreaInstitucional from '../AreaInstitucional';
import { ContactIcons, WhatsappIcon } from '../../components/Menu';
import Whatsapp from '../../components/Whatsapp';
import { logo, authTitle } from '../../config';
import {
  Container,
  SecondaryContainer,
  ContainerWhite,
  GreyContainer,
  Capa,
  ProgramContainer,
  Sponsors,
  Photo,
} from './styles';

import Button from '../../components/Button';
import getValidationErrors from '../../utils/getValidationErrors';
import SponsorsContainter from '../Sponsors';
import { useAuth } from '../../hooks/Auth';
import { useToast } from '../../hooks/Toast';
import { useModal } from '../../hooks/Modal';


import Publicas from './modules/publicas';

import { usePages } from '../../hooks/Pages';
import { useLanguage } from '../../hooks/Language';


interface SignInData {
  email: string;
  password: string;
}

interface IPublicData {
  icon: IconType;
  title: string;
  text: string;
}

const Home: React.FC = () => {
  const history = useHistory();
  const { signIn } = useAuth();
  const { addToast } = useToast();
  const { addModal, removeModal } = useModal();
  const formRef = useRef<FormHandles>(null);
  const [cardLayout, setCardLayout] = useState([] as Array<JSX.Element>);
  const { readPages } = usePages();
const {translate} = useLanguage();
  const [pages, setPages] = useState(readPages());

  const handleSubmit = useCallback(
    async (data: SignInData) => {
      try {
        formRef.current?.setErrors({});
        const schema = Yup.object().shape({
          email: Yup.string()
            .required('Email obrigatório')
            .email('Preencha um email válido'),
          password: Yup.string().required('Senha obrigatória'),
        });

        await schema.validate(data, { abortEarly: false });

        const { email, password } = data;

        await signIn({ email, password });
        history.push('/dashboard');
        return;
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
        }

        addToast({
          type: 'error',
          title: 'Erro na autenticação',
          description: 'Ocorreu um erro ao fazer login',
        });
      }
    },
    [signIn, addToast, history],
  );

  const buildCard: React.FC<IPublicData> = ({ icon, title, text }) => {
    return (
      <div
        onClick={() =>
          setCardLayout([<Publicas icon={icon} text={text} title={title} />])}
      >
        {icon({})}
        <p>{title}</p>
      </div>
    );
  };

  return (
    <>
      <Capa >
      <div className="p50"  style={{ display: 'flex', maxWidth: '540px', padding: '20px', alignItems: 'center', justifyContent:'flex-start', flexDirection: 'column'}}>
        <div style={{padding: '0px', position:'relative'}} >
        <img className='logo' src="/assets/logo-2.png" style={{width: '100%', opacity: 1, maxWidth: '600px', margin: '0px auto', marginTop: '50px'}}/>
        
        </div>
        <aside style={{width:'100%', display:'flex', justifyContent:'center'}}><p ><strong className='titleH' style={{color:'#fff'}}>{translate('17 E 18 DE MAIO, ON-LINE')}</strong> </p></aside>

        <div className='buttonsCapaDiv' >
        <Link to="/inscricao" style={{margin: '10px'}}><button className="defaultButton">{translate('INSCREVA-SE')}</button></Link>
         <Link to="/login" style={{margin: '10px'}}><button className="defaultButton" style={{textTransform:'uppercase'}}>{translate('ACESSAR')}</button></Link>
         <Link to="/certificados" style={{margin: '10px'}}><button className="defaultButton" style={{textTransform:'uppercase'}}>{translate('CERTIFICADOS')}</button></Link>
         <Link to="/programacao" style={{margin: '10px'}}><button className="defaultButton" style={{textTransform:'uppercase'}}>{translate('PROGRAMAÇÃO')}</button></Link>
         <Link to="/palestrantes" style={{margin: '10px'}}><button className="defaultButton" style={{textTransform:'uppercase'}}>{translate('PALESTRANTES')}</button></Link>
       
         </div>
       
    

     
        </div> 
      
      
      </Capa>
      <aside   style={{display:'flex', alignItems:'center', justifyContent:'center', width:'100%'}}>
      <aside   style={{display:'flex', flexDirection:'column', alignItems:'flex-start', justifyContent:'flex-start',maxWidth:'800px', padding:'20px', width:'100%'}}>
      <img src="/assets/logo-2.png" style={{width: '100%', opacity: 1, maxWidth: '300px',   marginTop: '50px'}}/>
      <p style={{paddingLeft:'12.1%'}}>17 E 18 DE MAIO, ON-LINE</p>
      </aside></aside>
      <Capa className='fundo2' style={{  minHeight:'80vh'}}>
        <div className='p50' style={{maxWidth:'800px', minWidth:'auto'}}>

         <p style={{color: '#333', fontSize:'16px', textAlign:'left'}}>
            <br/>
O tradicional evento, realizado anualmente na Região Sul, tem o objetivo de ampliar o conjunto de informações e fomentar a discussão sobre as questões mais relevantes que impactam o segmento de Previdência Complementar, além de estabelecer bases para uma educação permanente. 
<br/><br/><br/>Neste ano, o encontro será promovido pela <strong>Tchê Previdência</strong> e abordará o tema <strong>"Superação em Cenários Desafiadores"</strong> em quatro eixos temáticos: 
<br/><br/><br/>
<ul>
  <li>Atualização da legislação e oportunidades para o segmento</li>
  <li>Gestão de entidades - gestão de pessoas e comunicação para resultados</li>
  <li>Mercado, desafios e oportunidades em investimentos </li>
  <li>Perspectivas políticas e econômicas - possíveis impactos na gestão da previdência</li>
</ul>


<br/><br/>Com palestras e debates, o evento será 100% on-line e trará interações com o público diretamente do <strong>Estúdio Tchê.</strong>
<br/><br/><br/><Link style={{color: '#333', background: '#fcbf00', width:'auto', maxWidth:'470px', fontWeight:'bold', display:'flex', padding: '15px', borderRadius:'10px'}} to="/inscricao">Inscreva-se já e aproveite os valores especiais do 1º lote.</Link>

<br/><br/>*A participação neste evento contará pontos para o Programa de Educação Continuada do ICSS. 

       </p>
        </div>
      </Capa>
   
    </>
  );
};
export default Home;
